import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconEmailComponent } from "./med-icon-email.component";

@NgModule({
  declarations: [
    MedIconEmailComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconEmailComponent,
  ],
})
export class MedIconEmailModule { }
